import { render } from "./MedicalPaidBills.vue?vue&type=template&id=08a9c68a&scoped=true"
import script from "./MedicalPaidBills.vue?vue&type=script&lang=js"
export * from "./MedicalPaidBills.vue?vue&type=script&lang=js"

import "./MedicalPaidBills.vue?vue&type=style&index=0&id=08a9c68a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a9c68a"]])

export default __exports__